/* CR Fitness Staff Store — theme script */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: fmt }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* Mobile nav */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.getElementById('CrfNav');
    var header = t.closest('[data-header]');
    if (header) document.documentElement.style.setProperty('--crf-nav-top', header.getBoundingClientRect().bottom + 'px');
    var open = nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* Collection sort */
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Toast */
  var toast = document.getElementById('CrfToast');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    document.getElementById('CrfToastMsg').textContent = msg;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 7000);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-toast-close]')) toast.hidden = true;
  });

  function updateCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (b) {
          b.textContent = c.item_count;
          b.hidden = c.item_count === 0;
        });
      });
  }

  /* Product form */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    if (!form) return;
    var jsonEl = section.querySelector('[data-product-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var addLabel = form.querySelector('[data-add-label]');
    var addText = (addLabel && addLabel.dataset.label) || 'Add to cart';
    var soldText = (addLabel && addLabel.dataset.sold) || 'Sold out';
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var stockEl = form.querySelector('[data-stock]');
    var errEl = form.querySelector('[data-form-error]');
    var mainImg = section.querySelector('[data-main-image]');
    var fieldsets = form.querySelectorAll('[data-option-index]');

    function selected() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function markAvailability() {
      var sel = selected();
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('[data-option-input]').forEach(function (input) {
          var test = sel.slice(); test[i] = input.value;
          var match = variants.find(function (v) { return v.options.every(function (o, j) { return o === test[j]; }); });
          var label = form.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function render(v) {
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-option-value]');
        if (c && out) out.textContent = c.value;
      });
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        if (stockEl) stockEl.textContent = 'This combination is not offered.';
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        var showCmp = v.compare_at_price && v.compare_at_price > v.price;
        compareEl.hidden = !showCmp;
        if (showCmp) compareEl.textContent = formatMoney(v.compare_at_price);
      }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? addText : soldText;
      if (stockEl) stockEl.textContent = v.available ? '' : 'This size is sold out.';
      if (v.featured_image && mainImg) {
        mainImg.src = v.featured_image.src;
        mainImg.removeAttribute('srcset');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var sel = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, j) { return o === sel[j]; }); });
      render(v);
      markAvailability();
    });
    markAvailability();

    /* Quantity */
    var qty = form.querySelector('[data-qty-input]');
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10));
        qty.value = n;
      });
    });

    /* AJAX add to cart */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      errEl.hidden = true;
      addBtn.disabled = true;
      addLabel.textContent = 'Adding…';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Math.max(1, parseInt(qty.value, 10) || 1) }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart.');
          var item = res.d.items && res.d.items[0];
          showToast((item ? item.product_title + (item.variant_title ? ' (' + item.variant_title + ')' : '') : 'Item') + ' added to cart');
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { id: Number(idInput.value), qty: parseInt(qty.value, 10) || 1 } }));
          return updateCount();
        })
        .catch(function (err) { errEl.textContent = err.message; errEl.hidden = false; })
        .finally(function () { addBtn.disabled = false; addLabel.textContent = addText; });
    });

    /* Thumbnails */
    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) { mainImg.src = t.dataset.src; mainImg.removeAttribute('srcset'); }
        section.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  });

  /* Cart: highlight missing payroll details */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var cartErr = cartForm.querySelector('[data-cart-error]');
    cartForm.addEventListener('invalid', function (e) {
      e.target.classList.add('crf-is-invalid');
      if (cartErr) cartErr.hidden = false;
    }, true);
    cartForm.addEventListener('input', function (e) {
      if (e.target.checkValidity && e.target.checkValidity()) e.target.classList.remove('crf-is-invalid');
    });
    cartForm.addEventListener('change', function (e) {
      if (e.target.checkValidity && e.target.checkValidity()) e.target.classList.remove('crf-is-invalid');
    });
  }

  /* Product recommendations */
  document.querySelectorAll('[data-recs]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* v2: entrance motion */
  (function () {
    var els = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var groups = new Map();
    els.forEach(function (el) {
      var parent = el.closest('section') || document.body;
      var n = groups.get(parent) || 0; groups.set(parent, n + 1);
      el.style.setProperty('--reveal-delay', (n * 80) + 'ms');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (e) { e.classList.add('is-in'); }); }, 4000);
  })();

  /* v2: find your gear */
  document.querySelectorAll('[data-finder]').forEach(function (root) {
    var key = root.dataset.companyKey || 'Company';
    var saved = root.querySelector('[data-finder-saved]');
    var companyBtns = root.querySelectorAll('[data-finder-company]');
    function markCompany(name) {
      companyBtns.forEach(function (b) {
        var on = b.dataset.finderCompany === name;
        b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    var stored = null;
    try { stored = localStorage.getItem('crfCompany'); } catch (e) {}
    if (stored && !root.querySelector('[data-finder-company].is-active')) markCompany(stored);
    companyBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        var name = b.dataset.finderCompany;
        markCompany(name);
        try { localStorage.setItem('crfCompany', name); } catch (e) {}
        var attrs = {}; attrs[key] = name;
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
          .then(function () { if (saved) { saved.textContent = name + ' saved for checkout.'; saved.hidden = false; } })
          .catch(function () {});
      });
    });
    var roleTabs = root.querySelectorAll('[data-finder-role]');
    roleTabs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var id = t.dataset.finderRole;
        roleTabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        root.querySelectorAll('[data-finder-panel]').forEach(function (p) { p.hidden = p.dataset.finderPanel !== id; });
        root.querySelectorAll('[data-finder-photo]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.finderPhoto === id); });
      });
    });
  });

  /* v2: how-it-works accordion */
  document.querySelectorAll('[data-acc2]').forEach(function (root) {
    var panels = root.querySelectorAll('[data-acc2-panel]');
    panels.forEach(function (p) {
      var btn = p.querySelector('[data-acc2-toggle]');
      btn.addEventListener('click', function () {
        panels.forEach(function (q) {
          var on = q === p; q.classList.toggle('is-open', on);
          q.querySelector('[data-acc2-toggle]').setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      });
    });
  });

  /* v2: cart company pre-fill */
  var cartCompany = document.querySelector('[data-cart-company]');
  if (cartCompany && !cartCompany.value) {
    try {
      var sc = localStorage.getItem('crfCompany');
      if (sc && Array.prototype.some.call(cartCompany.options, function (o) { return o.value === sc; })) cartCompany.value = sc;
    } catch (e) {}
  }
})();
